import ModalAddTeam from './ModalAddTeam'
import ModalAgreement from './ModalAgreement'
import ModalWizardRenew from './ModalWizardRenew'
import ModalInviteMember from './ModalInviteMember'
import ModalBreakdownTags from './ModalBreakdownTags'
import ModalWizardWarning from './ModalWizardWarning'
import ModalCameraSupport from './ModalCameraSupport'
import ModalWizardRedirect from './ModalWizardRedirect'
import ModalWizardAccessory from './ModalWizardAccessory'
import ModalDeleteTagConfirm from './ModalDeleteTagConfirm'
import ModalHighlightCreating from './ModalHighlightCreating'
import ModalWizardSummaryInfo from './ModalWizardSummaryInfo'
import ModalManageSubscription from './ModalManageSubscription'
import ModalWizardSportCameraInfo from './ModalWizardSportCameraInfo'
import ModalDeleteUserTagConfirm from './ModalDeleteUserTagConfirm'
import ModalTagUsers from './ModalTagUsers'
import ModalFeedback from './ModalFeedback'
import ModalLoginConfirm from './ModalLoginConfirm'
import ModalWizardInstallment from './ModalWizardInstallment'
import ModalWizardKlarnaInfo from './ModalWizardKlarnaInfo'
import ModalDeleteClipConfirm from './ModalDeleteClipConfirm'
import ModalRenameClip from './ModalRenameClip'
import ModalWizardInvitedMembers from './ModalWizardInvitedMembers'
import ModalWizardSubscription from './ModalWizardSubscription'
import ModalConfirmUnpauseSubscription from './ModalConfirmUnpauseSubscription'
import ModalDeleteTeamConfirm from './ModalDeleteTeamConfirm'
import ModalWizardNewRenew from './ModalWizardNewRenew'
import ModalWizardMotivation from './ModalWizardMotivation'
import ModalWizardEmail from './ModalWizardEmail'
import ModalUserPasswordConfirm from './ModalUserPasswordConfirm'
import ModalPauseSubscription from './ModalPauseSubscription'
import ModalAnalyticsPopup from './ModalAnalyticsPopup'

export default {
	ModalAddTeam,
	ModalAgreement,
	ModalWizardRenew,
	ModalInviteMember,
	ModalBreakdownTags,
	ModalWizardWarning,
	ModalCameraSupport,
	ModalWizardRedirect,
	ModalWizardAccessory,
	ModalDeleteTagConfirm,
	ModalHighlightCreating,
	ModalWizardSummaryInfo,
	ModalManageSubscription,
	ModalWizardSportCameraInfo,
	ModalDeleteUserTagConfirm,
	ModalTagUsers,
	ModalFeedback,
	ModalLoginConfirm,
	ModalWizardInstallment,
	ModalWizardKlarnaInfo,
	ModalDeleteClipConfirm,
	ModalRenameClip,
	ModalWizardInvitedMembers,
	ModalWizardSubscription,
	ModalConfirmUnpauseSubscription,
	ModalDeleteTeamConfirm,
	ModalWizardNewRenew,
	ModalWizardMotivation,
	ModalWizardEmail,
	ModalUserPasswordConfirm,
	ModalPauseSubscription,
	ModalAnalyticsPopup
}
